import React from "react"

const CustomThemeContext = React.createContext({
  theme: "light",
  i18n: {locale: 'es-ES', phoneNumberFormattingRegionCode: 'ES'},
  setLocale: (i18n:any) => {}
})

export default CustomThemeContext;